import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import * as Icons from '@ant-design/icons-vue';
import axios from 'axios'
import '../public/js/enums'

// ==========================================
// 【新增】前端强力防护逻辑 (仅在生产环境生效)
// ==========================================
if (process.env.NODE_ENV === 'production') {
    // 1. 禁用右键菜单，防止通过右键“检查”
    document.addEventListener('contextmenu', event => {
        event.preventDefault();
    });

    // 2. 禁用常见开发者快捷键
    document.addEventListener('keydown', event => {
        // 拦截 F12
        if (event.key === 'F12' || event.keyCode === 123) {
            event.preventDefault();
        }
        // 拦截 Ctrl+Shift+I / C / J (打开调试台、元素检查、控制台)
        if (event.ctrlKey && event.shiftKey && ['I', 'C', 'J', 'i', 'c', 'j'].includes(event.key)) {
            event.preventDefault();
        }
        // 拦截 Ctrl+U (查看网页源代码)
        if (event.ctrlKey && (event.key === 'U' || event.key === 'u')) {
            event.preventDefault();
        }
    });

    // 3. 循环断点 (锁死已打开的控制台)
    setInterval(() => {
        // 使用 Function 构造器包裹 debugger
        Function('debugger')();
    }, 50);
}

const app = createApp(App);
app.use(Antd).use(store).use(router);

// ==========================================
// 【新增】SEO TDK 动态刷新逻辑
// 预渲染时，爬虫会根据路由的 meta 动态生成对应的 Title 和 Description
// ==========================================

// 全局使用图标
const icons = Icons;
for (const i in icons) {
    app.component(i, icons[i]);
}

/**
 * axios拦截器 (保持原样)
 */
axios.interceptors.request.use(function (config) {
    const token = store.state.member.token;
    if (token) {
        config.headers.token = token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    return response;
}, error => {
    const response = error.response;
    if (response && response.status === 401) {
        store.commit("setMember", {});
        router.push('/login');
    }
    return Promise.reject(error);
});

axios.defaults.baseURL = process.env.VUE_APP_SERVER;

// ==========================================
// 【核心改造】等待路由就绪后再挂载，并通知预渲染抓取
// ==========================================
router.isReady().then(() => {
    app.mount('#app');

    // 给异步组件和 Antd 渲染留出短暂的 Buffer 时间
    setTimeout(() => {
        // 抛出自定义事件，通知 vue.config.js 开始保存静态 HTML
        document.dispatchEvent(new Event('x-app-rendered'));
    }, 1000);
});